export enum ArticleTagType {
    Brand = 'brand',
    Category = 'category',
    Keyword = 'keyword',
}

export type ArticleTag = {
    type: ArticleTagType;
    value: string;
};

export type ArticleSummary = {
    author: string | null;
    createdAt: string;
    heroImageUrl: string | null;
    id: string;
    secondaryImageUrl: string | null;
    slug: string;
    title: string;
    topic: string;
};

export type Article = ArticleSummary & {
    content: string;
    description: string | null;
    updatedAt: string;
    subtitle: string | null;
    tags: ArticleTag[] | null;
};

export type FetchArticleParams = {
    slug: string;
    topic: string;
};

export type ArticleRequestParams = FetchArticleParams & {
    deployment: string;
};

export type ArticleSlice = {
    article: Article | null;
    error: string | null;
    loaded: boolean;
    loading: boolean;
    requestKey: string | null;
};

export const defaultArticleSlice: ArticleSlice = {
    article: null,
    error: null,
    loaded: false,
    loading: false,
    requestKey: null,
};

export const toArticleSummary = (article: Article): ArticleSummary => ({
    author: article.author,
    createdAt: article.createdAt,
    heroImageUrl: article.heroImageUrl,
    id: article.id,
    secondaryImageUrl: article.secondaryImageUrl,
    slug: article.slug,
    title: article.title,
    topic: article.topic,
});

export const getArticleRequestKey = ({ slug, topic }: FetchArticleParams): string => `${topic}/${slug}`;
